export default __webpack_public_path__ + "static/media/print-white.fc5793f5.svg";